import wrapWithProvider from './wrap-with-provider.tsx'
export const wrapRootElement = wrapWithProvider

require('prism-themes/themes/prism-ghcolors.css')
